import styled from "styled-components";
import { colors, font, radius } from "../../styles/theme/tokens";

export const DropDown = styled.div`
   display: flex;
   align-items: center;
   gap: 14px;
   width: 100%;
   padding: 16px 18px;
   cursor: pointer;
   border-radius: ${radius.lg};
   transition: background 0.15s ease;

   &:hover {
      background: ${colors.bg};
   }
`

export const IconWrapper = styled.span`
   display: grid;
   place-items: center;
   width: 40px;
   height: 40px;
   flex-shrink: 0;
   border-radius: ${radius.md};
   color: ${colors.brandDeep};
   background: ${colors.brandSoft};
`

export const DropDownTitle = styled.p`
   flex: 1;
   font-family: ${font.text};
   font-size: 16px;
   font-weight: 700;
   color: ${colors.ink};
`

export const Chevron = styled.span`
   display: grid;
   place-items: center;
   color: ${colors.muted};
   transform: rotate(${(props) => (props.$open ? "180deg" : "0deg")});
   transition: transform 0.2s ease;
`
